import { Button } from '@mui/material';
import Container from '@mui/material/Container';
import PermissionBasedGuard from 'src/auth/guard/permission-based-guard';
import { useAuthContext } from 'src/auth/hooks';
import CustomBreadcrumbs from 'src/components/custom-breadcrumbs/custom-breadcrumbs';
import Iconify from 'src/components/iconify';
import { RouterLink } from 'src/routes/components';
import { paths } from 'src/routes/paths';
import RestaurantPlangroupsList from './restaurant-plangroups-list';

export default function RestaurantPlanGroupPageView() {
  const { user, loading } = useAuthContext();

  if (loading) {
    return <div>Loading...</div>;
  }

  if (!user?.restaurants[0].id) {
    return <div>No restaurant found</div>;
  }

  return (
    <PermissionBasedGuard permissions={['partners:read:restaurants']} hasContent>
        <Container >
        <CustomBreadcrumbs
          heading="Plan Groups"
          sx={{ mb: 2 }}
          links={[{}]}
          action={
            <PermissionBasedGuard permissions={['partners:create:plangroups']}>
              <Button
                component={RouterLink}
                href={paths.dashboard.restaurant.plangroup.add(user?.restaurants[0]?.id.toString())}
                variant="contained"
                startIcon={<Iconify icon="mingcute:add-line" />}
              >
                Add Plan Group
              </Button>
            </PermissionBasedGuard>
          }
        />

    </Container>
        <RestaurantPlangroupsList id={user?.restaurants[0]?.id.toString()} />
    </PermissionBasedGuard>
  );
}
